var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacadeSimilarDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 520 500",
    style: {
      enableBackground: "new 0 0 520 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.facade-similar-st0{fill:none;}\n\t.facade-similar-st1{fill:#FFFFFF;}\n\t.facade-similar-st2{fill:none;stroke:#FFFFFF;stroke-width:1.5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "facade-similar-st0",
    d: "M240.5,217l-1.2-6c-2.4,4.4-4.7,8.3-6.7,11.6C235.2,220.6,237.9,218.6,240.5,217z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "facade-similar-st1",
    d: "M192.8,218.1c-0.8,0.7-1.6,1.3-2.6,1.7c-4,1.6-9-0.7-14.8-6.6l-5.5,59.3h38.8c-3.9-10.2-7.2-20.3-10-29.7 C196.5,235.2,194.3,226.6,192.8,218.1z M184.6,258.7c-3.8,0-6.9-3.1-6.9-6.9s3.1-6.9,6.9-6.9s6.9,3.1,6.9,6.9 S188.4,258.7,184.6,258.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "facade-similar-st1",
    d: "M195.2,184.1c0,0-0.6,0.3-1.4,3.1c-1.8,6.1-1.8,15.4,0,27.2c1.9-3.4,3.1-8.6,3.4-15.2 C197.5,190.5,196.1,184.5,195.2,184.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "facade-similar-st1",
    d: "M210.3,148c0.9,0.5,2.5-1.1,4.2-4.1c7.6-13.7,15.5-32.4,19.9-43.9h-21.6C206.6,121.9,206.3,145.9,210.3,148z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "facade-similar-st1",
    d: "M189.1,218.5c1.2-0.3,2.4-1.1,3.3-2.3c-1.9-11.1-2.5-21.9-0.2-29.4c0.9-2.9,1.8-4.2,3-4.1c0.5,0,2,0.1,2.9,6.1 c0.8,5.2,0.6,12.2-0.4,17.7c-0.6,3.4-1.7,7.3-3.8,10.1c1.3,7.7,3.3,16.3,6,25.7c2.8,9.6,6.2,19.8,10.1,30.2h0.9L244,100h-8 c-4.5,11.5-12.5,30.6-20.2,44.6c-1.8,3.3-3.6,5-5.1,5c-0.4,0-0.7-0.1-1.1-0.3c-3.8-2-3.8-15.4-2.7-26.3c0.8-8,2.3-15.8,4.3-23h-25.4 l-1.9,20.4c6.3,11.9,11.4,25,11.4,36.6c0,4.8-1.4,7.8-4.2,9c-0.8,0.3-1.7,0.5-2.7,0.5c-2.4,0-5.3-1-8.5-2.5l-4.4,47.3 C182.1,218.2,186.4,219.3,189.1,218.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "facade-similar-st1",
    d: "M190.5,164.5c2.2-0.9,3.3-3.4,3.3-7.6c0-10.6-4.4-22.7-10.1-33.8l-3.6,39.1 C184.5,164.5,188.1,165.5,190.5,164.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "facade-similar-st1",
    d: "M184.6,246.5c-3,0-5.4,2.4-5.4,5.4s2.4,5.4,5.4,5.4s5.4-2.4,5.4-5.4S187.6,246.5,184.6,246.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "facade-similar-st1",
    d: "M260.9,143.5c-0.1-3.9-0.6-4.9-0.8-5.1c-1.4,0.9-4.7,10.8-4.7,20.2c0,2.3,0.3,5.9,1.6,8 C259.6,158.3,261.1,150.3,260.9,143.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "facade-similar-st1",
    d: "M256.5,142.6c1.9-6.1,3.4-5.8,3.9-5.8c1.3,0.2,1.9,2.2,2,6.6c0.2,7.2-1.5,15.6-4.1,24.4 c0.3,0.2,0.6,0.3,0.9,0.5c3.7,1.2,9.7-3.5,15.6-9.6l-6.3-58.7H249l-17.4,72.6l7.3,36.2c6.4-11.8,13.3-26.5,17.7-40.5 C251.9,163.4,254.4,149,256.5,142.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "facade-similar-st1",
    d: "M254.2,214.9c-1.6-1.6-6.7-0.4-13.3,3.7l3.6,18.1C256.9,220.1,255.1,215.9,254.2,214.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "facade-similar-st1",
    d: "M271.7,230.1c-0.6-1-1-1.1-1.1-1.1c-2.4,0.6-4.3,18.7-5,43.5H284c-1.6-5.3-3.1-11.3-4.5-17.2 C277,244.9,274.6,235.1,271.7,230.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "facade-similar-st1",
    d: "M270.2,227.5c1-0.3,1.9,0.3,2.7,1.8c3.1,5.2,5.5,15.1,8,25.6c1.4,5.9,2.9,12.1,4.6,17.5h1.3l-11.9-111.8 c-7.6,7.7-13.3,10.7-17,8.8c-0.1,0-0.1-0.1-0.2-0.1c-4.6,14.5-11.9,29.8-18.5,41.8l1.2,6c6.3-3.8,12.2-5.7,14.7-3.2 c3.8,3.8-2.7,14.6-10.4,24.8l6.8,33.8h12.6c0.2-6.5,0.5-14,0.9-21C266.7,228.5,269.2,227.8,270.2,227.5z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "facade-similar-st2",
    d: "M286.5,338.9c-2.1,6.9-1.8,17.2,0.3,29.4C294.9,357.8,290.9,324.4,286.5,338.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-similar-st2",
    d: "M269.6,364.7l-5.5,58.9h38.5c-7.4-19.7-13.2-39.2-15.9-55.3C283.4,372.7,277.9,373.1,269.6,364.7z  M278.1,409.8c-3.4,0-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c3.4,0,6.1,2.7,6.1,6.1C284.2,407.1,281.5,409.8,278.1,409.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-similar-st2",
    d: "M288,308.8c0-10.7-4.4-22.8-10.1-33.9l-3.8,40.4C282.2,319.1,288,318.5,288,308.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-similar-st2",
    d: "M336.6,252.7h-8.2c-4.5,11.4-12.2,29.8-19.8,43.5c-9.2,16.6-11-15-3.3-43.5H280l-2.1,22.2 c5.7,11.1,10.1,23.2,10.1,33.9c0,9.7-5.8,10.3-13.8,6.5l-4.6,49.4c8.4,8.4,13.8,8,17.2,3.6c-2.1-12.2-2.4-22.5-0.3-29.4 c4.4-14.5,8.4,18.9,0.3,29.4c2.7,16.1,8.5,35.6,15.9,55.3h1.4L336.6,252.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-similar-st2",
    d: "M308.6,296.2c7.5-13.7,15.3-32.1,19.8-43.5h-23.1C297.6,281.2,299.4,312.8,308.6,296.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-similar-st2",
    d: "M350.8,320.1c2.7-8.9,4.5-17.4,4.3-24.7C354.6,275.2,343,312.9,350.8,320.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-similar-st2",
    d: "M365.8,381.6c4.6,7.9,7.8,27.3,12.2,42h1.5l-11.9-111.3c-8.9,8.9-14,10.2-16.8,7.7 c-4.4,14.1-11.4,29-17.7,40.8l1.7,8.5c13.3-7.9,22.3-5.2,3.9,19.5l7,34.7h12.7C359.1,400,361,373.5,365.8,381.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-similar-st2",
    d: "M365.8,381.6c-4.8-8.1-6.7,18.4-7.4,42H378C373.6,408.9,370.4,389.5,365.8,381.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-similar-st2",
    d: "M355.1,295.4c0.2,7.2-1.5,15.8-4.3,24.7c2.7,2.5,7.9,1.2,16.8-7.7l-6.4-59.6H343l-17.2,71.8l7.3,36.3 c6.4-11.8,13.4-26.7,17.7-40.8C343,312.9,354.6,275.2,355.1,295.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-similar-st2",
    d: "M334.8,369.3l3.9,19.5C357.1,364.1,348.1,361.4,334.8,369.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9732 -0.2298 0.2298 0.9732 -85.3115 74.6933)",
    className: "facade-similar-st2",
    cx: 278.1,
    cy: 403.7,
    rx: 6.1,
    ry: 6.1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacadeSimilarDesktop);
export default __webpack_public_path__ + "static/media/facade-similar-desktop.747775a2.svg";
export { ForwardRef as ReactComponent };